import { TransparentButton } from '@/features/shared/elements/Buttons'
import { NextLink } from '@/features/shared/elements/Link'
import { type ReactNode } from 'react'
import { css } from '@/features/shared/styles'
import styled from 'styled-components'
import { type NavLinkData } from '@/features/cms/components/CMS/types'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicGlobalStoreSelectionDrawer } from '@/features/shop/components/Drawer/GlobalStoreSelectionDrawer/DynamicGlobalStoreSelectionDrawer'

type StandardNavProps = {
  navItem: NavLinkData
  onClick: () => void
  children: ReactNode
  isCarousel: boolean
  displaySublocation: string
}

export const StandardNavItem = ({
  navItem,
  onClick,
  children,
  isCarousel,
  displaySublocation,
}: StandardNavProps) => {
  const { openDialog } = useHandleDialog()
  const { GLOBAL_HOMEPAGE } = useIsPage()

  return navItem.available_stores?.length && GLOBAL_HOMEPAGE ? (
    <ShelfButton
      data-is-carousel={isCarousel}
      onClick={() => {
        onClick()
        openDialog(DynamicGlobalStoreSelectionDrawer, {
          displaySublocation,
          stores: navItem.available_stores,
          link: navItem.link,
          heading: navItem.heading,
          subheading: navItem.link.text,
          trackingContent: 'category_retailers_panel',
        })
      }}
    >
      {children}
    </ShelfButton>
  ) : (
    <ShelfLink href={navItem.link.url} onClick={onClick} data-is-carousel={isCarousel}>
      {children}
    </ShelfLink>
  )
}

const ShelfStyles = css`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  white-space: pre-wrap;
  flex: 1;

  &[data-is-carousel='true'] {
    max-width: 8rem;
  }

  &[data-is-carousel='false'] {
    margin-right: 1.6rem;
  }

  &:last-child {
    margin-right: 0;
  }
`
const ShelfButton = styled(TransparentButton)<{
  'data-is-carousel': boolean
}>`
  ${ShelfStyles}
`
const ShelfLink = styled(NextLink)<{
  'data-is-carousel': boolean
}>`
  ${ShelfStyles}
`
